<template>
<div class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <card>
                    <h4 slot="header" class="card-title">Admin User Data</h4>
                    <form @submit.prevent="addNewUser">
                        <div class="row">
                            <div class="col-md-6">
                                <base-input type="text" label="Name" placeholder="Name" v-model="user.name"></base-input>
                            </div>
                            <div class="col-md-6">
                                <base-input type="text" label="Username" placeholder="Username" v-model="user.username"></base-input>
                            </div>
                            <div class="col-md-6">
                                <base-input type="password" label="Password" placeholder="Password" v-model="user.password"></base-input>
                            </div>
                            <div class="col-md-6">
                                <!-- Select input with options -->
                                <label for="roleSelect">Role</label>
                                <select class="form-control" id="roleSelect" v-model="user.role">
                                    <option value="" disabled>Select a role</option>
                                    <option v-for="option in roleOptions" :key="option.value" :value="option.value">
                                        {{ option.label }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="text-center">
                            <button type="submit" class="btn btn-primary btn-fill float-right btn-sm">
                                Add
                            </button>
                        </div>
                    </form>
                </card>
            </div>
            <div class="col-12">
                <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
                    <template slot="header">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <h4 class="card-title">User List</h4>
                                <!-- <p class="card-category">Here is a subtitle for this table</p> -->
                            </div>
                            <!-- <button @click="clearInput" class="btn btn-primary btn-sm">Add</button> -->
                        </div>
                    </template>
                    <template v-if="usersList.length === 0">
                        <div class="card-body">
                            <div class="col-md-12">No data</div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="card-body">
                            <div class="mb-3">
                                <button @click="deleteSelectedUsers" class="btn btn-danger btn-sm">Delete Selected Users</button>
                                <button @click="deleteAllUsers" class="btn btn-danger btn-fill btn-sm ml-2">Delete All</button>
                            </div>
                            <!-- Scrollable container -->
                            <div class="table-scroll-container">
                                <table id="myTable" class="table table-hover table-striped">
                                    <thead>
                                        <tr>
                                            <th><input type="checkbox" v-model="selectAll" @change="toggleSelectAll" /></th>
                                            <th v-for="column in tableColumns" :key="column">{{ column }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in usersList" :key="index">
                                            <template v-if="editIndex === index">
                                                <td><input type="checkbox" :value="item.id" v-model="selectedUsers" disabled /></td>
                                                <td><input v-model="editItem.id" class="form-control" disabled /></td>
                                                <td><input v-model="editItem.name" class="form-control" /></td>
                                                <td><input v-model="editItem.username" class="form-control" /></td>
                                                <td>
                                                    <select class="form-control" v-model="editItem.role">
                                                        <option v-for="option in roleOptions" :key="option.value" :value="option.value">
                                                            {{ option.label }}
                                                        </option>
                                                    </select>
                                                </td>
                                                <td>
                                                    <select class="form-control" v-model="editItem.status">
                                                        <option value="1">Active</option>
                                                        <option value="0">Deactivated</option>
                                                    </select>
                                                </td>
                                                <td><input v-model="editItem.created_datetime" class="form-control" disabled /></td>
                                                <td><input v-model="editItem.updated_datetime" class="form-control" disabled /></td>
                                                <td>
                                                    <button @click="saveUser(index)" class="btn btn-success btn-sm">Save</button>
                                                    <button @click="cancelEdit" class="btn btn-secondary btn-sm">Cancel</button>
                                                </td>
                                            </template>
                                            <template v-else>
                                                <td><input type="checkbox" :disabled="item.name =='Ah Boy' && item.id == '1' " :value="item.id" v-model="selectedUsers" /></td>
                                                <td>{{ item.id }}</td>
                                                <td>{{ item.name }}</td>
                                                <td>{{ item.username }}</td>
                                                <td>{{ item.role }}</td>
                                                <td>{{ item.status }}</td>
                                                <td>{{ item.created_datetime }}</td>
                                                <td>{{ item.updated_datetime }}</td>
                                                <td>
                                                    <button :disabled="item.name =='Ah Boy' && item.id == '1' " @click="editUser(index, item)" class="btn btn-primary btn-sm">Edit</button>
                                                    <button :disabled="item.name =='Ah Boy' && item.id == '1' " @click="deleteUser(item.id)" class="btn btn-danger btn-sm">Delete</button>
                                                </td>
                                            </template>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </template>

                </card>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Card from 'src/components/Cards/Card.vue';
import axios from 'axios';
import {
    fetchUsers
} from 'src/utils/api';

export default {
    components: {
        Card
    },
    data() {
        return {
            editIndex: -1,
            editItem: {},
            selectedUsers: [],
            selectAll: false,
            user: {
                name: '',
                username: '',
                password: '',
                role: ''
            },
            roleOptions: [
                { value: 'member', label: 'Member' },
                { value: 'admin', label: 'Admin' }
            ],
            tableColumns: ['Id', 'Name', 'Username', 'Role', 'Status', 'Create At', 'Last Update', 'Action'],
            usersList: []
        };
    },
    watch: {
        selectedUsers(val) {
            if (this.selectedUsers.length === this.usersList.length) {
                this.selectAll = true
            } else this.selectAll = false
        }
    },
    methods: {
        clearInput() {
            this.user = {
                name: '',
                username: '',
                password: '',
                role: ''
            };
        },
        addNewUser() {
            if (this.user.name.trim() === '') {
                alert('Name cannot be empty');
                return;
            }
            if (confirm(`Are you sure to insert ${this.user.name}?`)) {
                let apiUrl = `${process.env.VUE_APP_BASE_URL}?action=create&type=user`
                axios.post(apiUrl, this.user)
                    .then(response => {
                        if (response.data.status === 'success') {
                            alert(response.data.message);
                            this.loadUsers();
                            this.clearInput();
                        } else {
                            alert('Error: ' + response.data.message);
                        }
                    })
                    .catch(error => {
                        alert('Network Error: ' + error);
                    });
            }
        },
        async loadUsers() {
            this.usersList = []
            try {
                const data = await fetchUsers('admin');
                this.usersList = [{
                    id: '1',
                    name: 'Ah Boy',
                    username: 'admin',
                    role: 'admin',
                    status: '1',
                    created_datetime: '',
                    updated_datetime: '',
                },...data];
                this.$nextTick(() => {
                    // Destroy existing DataTable if it exists
                    if ($.fn.DataTable.isDataTable('#myTable')) {
                        $('#myTable').DataTable().destroy();
                    }

                    // Reinitialize DataTable
                    $('#myTable').DataTable({
                        pageLength: 10, // Default number of rows to display
                        lengthMenu: [10, 25, 50, 100], // Options for number of rows per page
                        language: {
                            lengthMenu: "Show _MENU_ entries" // Customize the text for the page length menu
                        }
                    });
                });
            } catch (error) {
                alert(error.message);
            }
        },
        saveUser(index) {
            if (confirm('Are you sure to update?')) {
                let apiUrl = `${process.env.VUE_APP_BASE_URL}?action=update&type=user`
                axios.post(apiUrl, this.editItem)
                    .then(response => {
                        if (response.data.status === 'success') {
                            this.$set(this.usersList, index, this.editItem);
                            this.cancelEdit();
                            alert(response.data.message);
                            this.loadUsers();
                        } else {
                            alert('Error: ' + response.data.message);
                        }
                    })
                    .catch(error => {
                        alert('Network Error: ' + error);
                    });
            }
        },
        editUser(index, item) {
            this.editIndex = index;
            this.editItem = {
                ...item
            };
        },
        cancelEdit() {
            this.editIndex = -1;
            this.editItem = {};
        },
        deleteUser(id) {
            if (confirm('Are you sure to delete this user?')) {
                let apiUrl = `${process.env.VUE_APP_BASE_URL}?action=delete&type=user`
                axios.post(apiUrl, {
                        ids: [id]
                    })
                    .then(response => {
                        if (response.data.status === 'success') {
                            alert(response.data.message);
                            this.loadUsers();
                        } else {
                            alert('Error: ' + response.data.message);
                        }
                    })
                    .catch(error => {
                        alert('Network Error: ' + error);
                    });
            }
        },
        deleteSelectedUsers() {
            if (this.selectedUsers.length === 0) {
                alert('No users selected');
                return;
            }
            if (confirm(`Are you sure to delete selected users? ${JSON.stringify(this.selectedUsers)}`)) {
                let apiUrl = `${process.env.VUE_APP_BASE_URL}?action=delete&type=user`
                axios.post(apiUrl, {
                        ids: this.selectedUsers
                    })
                    .then(response => {
                        if (response.data.status === 'success') {
                            alert(response.data.message);
                            this.selectAll = false;
                            this.loadUsers();
                            this.selectedUsers = [];
                        } else {
                            alert('Error: ' + response.data.message);
                        }
                    })
                    .catch(error => {
                        alert('Network Error: ' + error);
                    });
            }
        },
        deleteAllUsers() {
            if (confirm('Are you sure to delete all users?')) {
                let apiUrl = `${process.env.VUE_APP_BASE_URL}?action=delete&type=user`
                axios.post(apiUrl, {
                        clear_all: true
                    })
                    .then(response => {
                        if (response.data.status === 'success') {
                            alert(response.data.message);
                            this.loadUsers();
                        } else {
                            alert('Error: ' + response.data.message);
                        }
                    })
                    .catch(error => {
                        alert('Network Error: ' + error);
                    });
            }
        },
        toggleSelectAll() {
            this.selectedUsers = this.selectAll ? this.usersList.map(user => user.id) : [];
        },
        toggleSelectUser(id) {
            const index = this.selectedUsers.indexOf(id);
            if (index > -1) {
                this.selectedUsers.splice(index, 1);
            } else {
                this.selectedUsers.push(id);
            }
            this.selectAll = this.selectedUsers.length === this.usersList.length;
        }
    },
    mounted() {
        this.loadUsers();
    }
};
</script>

<style scoped>
.table-scroll-container {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    /* Smooth scrolling for touch devices */
    width: 100%;
}

.table {
    min-width: 1000px;
    /* Adjust based on your table's width */
}
</style>
